var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCorporates(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48.882,
    height: 41.129,
    viewBox: "0 0 48.882 41.129",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Corporates",
    transform: "translate(0 -0.025)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_170",
    "data-name": "Rectangle 170",
    width: 11.765,
    height: 2.859,
    transform: "translate(20.961 15.116)",
    fill: "#ec0000"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_171",
    "data-name": "Rectangle 171",
    width: 11.765,
    height: 2.859,
    transform: "translate(20.961 26.571)",
    fill: "#ec0000"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_172",
    "data-name": "Rectangle 172",
    width: 11.765,
    height: 2.859,
    transform: "translate(20.961 20.843)",
    fill: "#ec0000"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_173",
    "data-name": "Rectangle 173",
    width: 2.859,
    height: 3.931,
    transform: "translate(10.179 28.729)",
    fill: "#ec0000"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_174",
    "data-name": "Rectangle 174",
    width: 2.859,
    height: 3.931,
    transform: "translate(5.47 28.729)",
    fill: "#ec0000"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_175",
    "data-name": "Rectangle 175",
    width: 2.859,
    height: 3.931,
    transform: "translate(10.179 20.89)",
    fill: "#ec0000"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_176",
    "data-name": "Rectangle 176",
    width: 2.859,
    height: 3.931,
    transform: "translate(5.47 20.89)",
    fill: "#ec0000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1471",
    "data-name": "Path 1471",
    d: "M318.563,267.1v-9.784h-5.974a5.873,5.873,0,0,0-11.253,0h-5.853v8.514h-15.3v28.427h2.859V268.686h12.444v25.568h2.859V260.172H301.2a5.877,5.877,0,0,0,11.516,0H315.7v34.082h2.859v-24.3H326.2v24.3h2.859V267.1Zm-11.6-5.082A3.017,3.017,0,1,1,309.979,259,3.017,3.017,0,0,1,306.961,262.016Z",
    transform: "translate(-280.18 -253.1)",
    fill: "#ec0000"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_177",
    "data-name": "Rectangle 177",
    width: 2.859,
    height: 3.931,
    transform: "translate(40.891 28.729)",
    fill: "#ec0000"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_178",
    "data-name": "Rectangle 178",
    width: 2.859,
    height: 3.931,
    transform: "translate(40.891 21.107)",
    fill: "#ec0000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1472",
    "data-name": "Path 1472",
    d: "M216.38,378.464h2.859v-4.605h7.94v4.605h2.859V371H216.38Z",
    transform: "translate(-196.744 -337.309)",
    fill: "#ec0000"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_179",
    "data-name": "Rectangle 179",
    width: 2.859,
    height: 6.035,
    transform: "translate(7.567 35.12)",
    fill: "#ec0000"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_180",
    "data-name": "Rectangle 180",
    width: 2.859,
    height: 6.035,
    transform: "translate(40.599 35.12)",
    fill: "#ec0000"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCorporates);
export default __webpack_public_path__ + "static/media/Corporates.94a84f0d978e617628b5a24fdb3354bd.svg";
export { ForwardRef as ReactComponent };